import "@ant-design/v5-patch-for-react-19";
import "./global.css";
import "./theme/theme.css";
import "./locales/i18n";
import { QueryClientProvider } from "@tanstack/react-query";
import { QueryClient } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";
import App from "./App";
import { registerLocalIcons } from "./components/icon";
import { saveCliAuthReturnFromLocation } from "./utils/cli-auth-return";

// bujuan CLI 授权流:落在 /cli-auth 时最早期就保存回跳地址——若 localStorage 残留
// 已失效 token,App 层 useUser 会先 401 并被 apiClient 硬跳 /login,页面来不及保存
saveCliAuthReturnFromLocation();

await registerLocalIcons();

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement,
);
root.render(
	<QueryClientProvider client={new QueryClient()}>
		<App />
	</QueryClientProvider>,
);
